'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryApiCacheService = void 0;
var DEFAULT_TTL = 60; // 1 minute default cache timeout
var InMemoryApiCacheService = /** @class */ (function () {
    /**
     * To be used only internally as this class implements singleton pattern
     */
    function InMemoryApiCacheService() {
        /**
         * Map containing the in-memory cached content. Key, value store
         */
        this.cacheStore = new Map();
    }
    /**
     * Public method to get access to the singleton instance of the cache service
     */
    InMemoryApiCacheService.getInstance = function () {
        if (!InMemoryApiCacheService.instance) {
            InMemoryApiCacheService.instance = new InMemoryApiCacheService();
        }
        return InMemoryApiCacheService.instance;
    };
    InMemoryApiCacheService.prototype.get = function (key) {
        if (!this.cacheStore.has(key)) {
            return null;
        }
        var cachedResponse = this.cacheStore.get(key);
        if (cachedResponse === undefined) {
            return null;
        }
        if (cachedResponse.expirationTimestamp < Date.now()) {
            this.cacheStore.delete(key);
            return null;
        }
        return cachedResponse.response;
    };
    InMemoryApiCacheService.prototype.set = function (key, response, ttl) {
        var secondsTimeout = isNaN(ttl) ? DEFAULT_TTL : ttl;
        var expirationTimestamp = Date.now() + secondsTimeout * 1000;
        this.cacheStore.set(key, { response: response, expirationTimestamp: expirationTimestamp });
        return expirationTimestamp;
    };
    InMemoryApiCacheService.prototype.deleteCached = function (key) {
        this.cacheStore.delete(key);
    };
    InMemoryApiCacheService.prototype.purge = function () {
        var _this = this;
        var now = Date.now();
        var removed = [];
        this.cacheStore.forEach(function (response, key) {
            if (response.expirationTimestamp < now) {
                _this.cacheStore.delete(key);
                removed.push(key);
            }
        });
        return removed;
    };
    return InMemoryApiCacheService;
}());
exports.InMemoryApiCacheService = InMemoryApiCacheService;
